(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var $url = document.querySelector('.as-finishes-gallery-script')
      if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
        window._finishesGallery = $url.value
        var $script = document.createElement('script')
        $script.src = window._finishesGallery
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-zoom-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-screen-zoom-text-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  var $gallerys = document.querySelectorAll('.as-gallery-v2');
  var galleryWrapper = document.querySelector('.as-gallery-v2-wrapper')
  var enableForcedScrolling = galleryWrapper?.dataset.enableForcedScrolling
  var $navBar = document.querySelector('.as-sticky-nav-bar-pdp');
  var screenHeight = window.innerHeight;
  var navBarHeight = $navBar.clientHeight;
  var visibleHeight = screenHeight - navBarHeight;

  if (enableForcedScrolling === 'true') {
    $gallerys.forEach(function($gallery) {
      var $galleryWrapper = $gallery.querySelector('.as-gallery-v2-wrapper');
      if ($galleryWrapper == null) return;
      var $galleryMainContent = $galleryWrapper.querySelector('.as-gallery-main-content');
      if ($galleryMainContent == null) return;
      var totalHeight = $galleryWrapper.clientHeight;
      var $cardContainer = $galleryWrapper.querySelector('.as-card-container');
      if ($cardContainer == null) return;
      var mainContentOffsetTop = $galleryWrapper.querySelector('.as-card-container').offsetTop;
      var mainContentHeight = $galleryMainContent.clientHeight;
      var top = 0;
      if (totalHeight > visibleHeight) {
        if (mainContentHeight > visibleHeight) {
          top = (mainContentOffsetTop - ((mainContentHeight - visibleHeight) / 2)) * -1 + 'px';
        } else {
          top = (mainContentOffsetTop - ((visibleHeight - mainContentHeight) / 2)) * -1 + 'px';
        }
      } else {
        top = (visibleHeight - totalHeight) / 2 + 'px';
      }
      $gallery.style.setProperty('--top', top);
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-floating-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-and-floating-card-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab-pdp-z70u"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-main-product-v2-script');
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value;
      var $script = document.createElement('script');
      $script.src = window.productV2;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  const gradientBlock = document.getElementById('gradientBlock');
  const container = document.getElementById('gradientContainer');
  if (gradientBlock == null) return;

  // 页面加载时将色块居中
  function centerGradientBlock() {
    const containerRect = container.getBoundingClientRect();
    const x = (containerRect.width - gradientBlock.offsetWidth) / 2;
    const y = (containerRect.height - gradientBlock.offsetHeight) / 2;
    gradientBlock.style.left = `${x}px`;
    gradientBlock.style.top = `${y}px`;
  }

  // 检查视口大小
  function checkViewportSize() {
    if (window.innerWidth >= 768) {
      // 初始化色块位置
      centerGradientBlock();

      // 处理鼠标移动事件
      document.addEventListener('mousemove', handleMouseMove);
    } else {
      // 移除鼠标移动事件监听器
      document.removeEventListener('mousemove', handleMouseMove);
    }
  }

  // 处理鼠标移动事件
  function handleMouseMove(event) {
    const containerRect = container.getBoundingClientRect();
    const x = event.clientX - containerRect.left - gradientBlock.offsetWidth / 2;
    const y = event.clientY - containerRect.top - gradientBlock.offsetHeight / 2;

    // 限制色块在容器内
    gradientBlock.style.left = `${Math.max(0, Math.min(containerRect.width - gradientBlock.offsetWidth, x))}px`;
    gradientBlock.style.top = `${Math.max(0, Math.min(containerRect.height - gradientBlock.offsetHeight, y))}px`;
  }

  // 初始化视口大小检查
  checkViewportSize();

  // 监听窗口大小变化
  window.addEventListener('resize', checkViewportSize);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-multicolumn-swiper-script')
    if (!window.MulticolumnSwipers && $url) {
      window.MulticolumnSwipers = $url.value

      var $script = document.createElement('script')
      $script.src = window.MulticolumnSwipers
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-pdp-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-unlock-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scroll-unlock-cards-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-v2-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner-z70"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
